import { useEffect } from 'react';
import { startOpenClub } from '../utils/openClub';

// Landing page for a club opened from the super admin portal: the token comes
// after the # so it never reaches a server log
export default function OpenClub() {
  useEffect(() => {
    const token = window.location.hash.slice(1);
    window.history.replaceState(null, '', '/open-club');
    if (token) startOpenClub(token);
    else window.location.replace('/login');
  }, []);
  return <div className="loading"><div className="spinner" /></div>;
}
